  <template>
    <div>
      <AppHeader />
      <div class="article">
        <v-container
          class="pt-0 pb-0"
        >

          <v-layout>
            <v-flex
              xs12
            >
            <v-breadcrumbs :items="breadcrumbs">
              <template v-slot:divider>
                <v-icon>chevron_right</v-icon>
                </template>
                </v-breadcrumbs>
              <v-card
                class="article__card no-round elevation-0"
              >
                <v-img  style="margin-top: 10px;"
                  v-if="getArticle.header_image"
                  :src="getArticle.header_image"
                  aspect-ratio="2.75"
                ></v-img>
                <v-img style="margin-top: 10px;" 
                v-else
                :src="require('../assets/article-background.jpg')"
                >
                </v-img>

                <v-card-title>
                  <div v-bind:style="{width: '100%'}">
                    <h1 class="article__title pl-0">{{getArticle.title}}</h1>
                    <div id="content" v-html="getArticle.content" class="article__text_preview"></div>
                  </div>
                </v-card-title>

              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <br>
        <br>
        <br>
        <br>
        <br>
        <BottomNavigation />
      </div>
    </div>
  </template>

  <script>
    import AppHeader from '../components/AppHeader';
    import BottomNavigation from "../components/BottomNavigation";
        import { mapGetters } from "vuex";

    // import DevelopmentSection from '../components/DevelopmentSection';
    export default {
      name: 'Article',
      components: {
        AppHeader,
        BottomNavigation,
        // DevelopmentSection
      },
              computed: {
        ...mapGetters(
          'articles', ['getArticle', 'getError'],
          ),
          breadcrumbs() {
                    return [{
            text: 'Articles',
            disabled: false,
            href: '/articles'
          },
          {
            text: this.getArticle.title,
            disabled: true,
            //href: '/articles'
          }
                    ]}, 
      },
          mounted() {
          const article_id = this.$route.params.id;
        this.$store.dispatch('articles/articleRequest', article_id);
      },
    }
  </script>

  <style scoped>
    .article__text_preview {
      position: relative;
      word-break:break-word;
      word-wrap:break-word;
  }
    .article__text_preview >>> ul {padding-bottom: 16px;}
    .article__text_preview >>> img {
    max-width:100%;
    height:auto;
    }
  </style>
